import React from "react";

export const EyeIcon = () => {
  return <div></div>;
};

export const HomeIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8253 19.2506H5.17533C2.89199 19.2506 1.04199 17.3923 1.04199 15.109V8.93396C1.04199 7.80063 1.74199 6.37563 2.64199 5.67563L7.13366 2.17563C8.48366 1.12563 10.642 1.07563 12.042 2.05896L17.192 5.6673C18.1837 6.35896 18.9587 7.8423 18.9587 9.05063V15.1173C18.9587 17.3923 17.1087 19.2506 14.8253 19.2506ZM7.90033 3.15896L3.40866 6.65896C2.81699 7.12563 2.29199 8.18396 2.29199 8.93396V15.109C2.29199 16.7006 3.58366 18.0006 5.17533 18.0006H14.8253C16.417 18.0006 17.7087 16.709 17.7087 15.1173V9.05063C17.7087 8.25063 17.1337 7.1423 16.4753 6.6923L11.3253 3.08396C10.3753 2.4173 8.80866 2.45063 7.90033 3.15896Z"
        fill="currentColor"
      />
      <path
        d="M10 15.9175C9.65833 15.9175 9.375 15.6341 9.375 15.2925V12.7925C9.375 12.4508 9.65833 12.1675 10 12.1675C10.3417 12.1675 10.625 12.4508 10.625 12.7925V15.2925C10.625 15.6341 10.3417 15.9175 10 15.9175Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const RequestIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0003 14.4591V16.4425C10.0003 18.0008 9.37533 18.6258 7.80866 18.6258H3.85033C2.29199 18.6258 1.66699 18.0008 1.66699 16.4425V12.4841C1.66699 10.9175 2.29199 10.2925 3.85033 10.2925H5.83366V12.2675C5.83366 13.8341 6.45866 14.4591 8.01699 14.4591H10.0003Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1663 10.2926V12.2676C14.1663 13.8343 13.5413 14.4593 11.9747 14.4593H8.01634C6.45801 14.4593 5.83301 13.8343 5.83301 12.2676V8.30931C5.83301 6.75098 6.45801 6.12598 8.01634 6.12598H9.99967V8.10098C9.99967 9.66764 10.6247 10.2926 12.183 10.2926H14.1663Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 4.14232V8.10065C18.3333 9.66732 17.7083 10.2923 16.1417 10.2923H12.1833C10.625 10.2923 10 9.66732 10 8.10065V4.14232C10 2.58398 10.625 1.95898 12.1833 1.95898H16.1417C17.7083 1.95898 18.3333 2.58398 18.3333 4.14232Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EmploymentIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Head/Profile circle */}
      <circle
        cx="10"
        cy="6.5"
        r="3.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Body/Shoulders */}
      <path
        d="M3.33301 17.1673C3.33301 14.4059 6.31778 12.1673 9.99967 12.1673C13.6816 12.1673 16.6663 14.4059 16.6663 17.1673"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Badge/ID indicator on chest */}
      <rect
        x="8.5"
        y="13.5"
        width="3"
        height="2"
        rx="0.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const AppraisalIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.50033 18.6257H12.5003C16.667 18.6257 18.3337 16.959 18.3337 12.7923V7.79232C18.3337 3.62565 16.667 1.95898 12.5003 1.95898H7.50033C3.33366 1.95898 1.66699 3.62565 1.66699 7.79232V12.7923C1.66699 16.959 3.33366 18.6257 7.50033 18.6257Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9593 9.38425C11.8759 9.97592 11.5259 10.4759 11.0426 10.7759V12.4259C11.0426 13.0009 10.5759 13.4676 10.0009 13.4676C9.42592 13.4676 8.95925 13.0009 8.95925 12.4259V10.7759C8.47592 10.4759 8.12591 9.97592 8.04258 9.38425C8.02591 9.29258 8.01758 9.19258 8.01758 9.09258C8.01758 7.82591 9.21759 6.84258 10.5343 7.19258C11.2009 7.36758 11.7426 7.90925 11.9176 8.57592C11.9926 8.85092 12.0009 9.12592 11.9593 9.38425Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M18.335 9.38428H11.96"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M8.04199 9.38428H1.66699"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export const FinancialIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7663 2.17568L16.1913 5.10068C16.8247 5.44235 16.8247 6.41735 16.1913 6.75902L10.7663 9.68402C10.283 9.94235 9.71634 9.94235 9.23301 9.68402L3.80801 6.75902C3.17467 6.41735 3.17467 5.44235 3.80801 5.10068L9.23301 2.17568C9.71634 1.91735 10.283 1.91735 10.7663 2.17568Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.00866 8.73421L8.05033 11.2592C8.67533 11.5759 9.07533 12.2175 9.07533 12.9175V17.6842C9.07533 18.3759 8.35033 18.8175 7.73366 18.5092L2.69199 15.9842C2.06699 15.6675 1.66699 15.0259 1.66699 14.3259V9.55921C1.66699 8.86754 2.39199 8.42588 3.00866 8.73421Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9915 8.73421L11.9498 11.2592C11.3248 11.5759 10.9248 12.2175 10.9248 12.9175V17.6842C10.9248 18.3759 11.6498 18.8175 12.2665 18.5092L17.3081 15.9842C17.9331 15.6675 18.3331 15.0259 18.3331 14.3259V9.55921C18.3331 8.86754 17.6081 8.42588 16.9915 8.73421Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SubscriptionIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.50879 9.64258V13.3842C2.50879 17.1259 4.00879 18.6259 7.75046 18.6259H12.2421C15.9838 18.6259 17.4838 17.1259 17.4838 13.3842V9.64258"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99975 10.2923C11.5247 10.2923 12.6497 9.05065 12.4997 7.52565L11.9497 1.95898H8.05808L7.49975 7.52565C7.34975 9.05065 8.47475 10.2923 9.99975 10.2923Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2587 10.2923C16.942 10.2923 18.1753 8.92565 18.0087 7.25065L17.7753 4.95898C17.4753 2.79232 16.642 1.95898 14.4587 1.95898H11.917L12.5003 7.80065C12.642 9.17565 13.8837 10.2923 15.2587 10.2923Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.69966 10.2923C6.07466 10.2923 7.31632 9.17565 7.44966 7.80065L7.63299 5.95898L8.03299 1.95898H5.49133C3.30799 1.95898 2.47466 2.79232 2.17466 4.95898L1.94966 7.25065C1.78299 8.92565 3.01632 10.2923 4.69966 10.2923Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0003 14.459C8.60866 14.459 7.91699 15.1507 7.91699 16.5423V18.6257H12.0837V16.5423C12.0837 15.1507 11.392 14.459 10.0003 14.459Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ProfileIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1331 9.35065C10.0498 9.34232 9.9498 9.34232 9.85814 9.35065C7.8748 9.28398 6.2998 7.65898 6.2998 5.65898C6.2998 3.61732 7.9498 1.95898 9.9998 1.95898C12.0415 1.95898 13.6998 3.61732 13.6998 5.65898C13.6915 7.65898 12.1165 9.28398 10.1331 9.35065Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.9666 12.426C3.94993 13.776 3.94993 15.976 5.9666 17.3176C8.25827 18.851 12.0166 18.851 14.3083 17.3176C16.3249 15.9676 16.3249 13.7676 14.3083 12.426C12.0249 10.901 8.2666 10.901 5.9666 12.426Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NotificationIcon = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.953 10.8867C13.7663 11.3867 13.373 11.7667 12.8597 11.94C12.1397 12.18 11.3997 12.36 10.653 12.4867C10.5797 12.5 10.5063 12.5134 10.433 12.52C10.313 12.54 10.193 12.5534 10.073 12.5667C9.92633 12.5867 9.773 12.6 9.61967 12.6134C9.19967 12.6467 8.78633 12.6667 8.36633 12.6667C7.93967 12.6667 7.513 12.6467 7.093 12.6067C6.913 12.5934 6.73967 12.5734 6.56633 12.5467C6.46633 12.5334 6.36633 12.52 6.273 12.5067C6.19967 12.4934 6.12633 12.4867 6.053 12.4734C5.313 12.3534 4.57967 12.1734 3.86633 11.9334C3.333 11.7534 2.92633 11.3734 2.74633 10.8867C2.56633 10.4067 2.633 9.8467 2.91967 9.3667L3.673 8.11337C3.833 7.84003 3.97967 7.31337 3.97967 6.99337V5.75337C3.97967 3.33337 5.94633 1.3667 8.36633 1.3667C10.7797 1.3667 12.7463 3.33337 12.7463 5.75337V6.99337C12.7463 7.31337 12.893 7.84003 13.0597 8.11337L13.813 9.3667C14.0863 9.83337 14.1397 10.38 13.953 10.8867Z"
        fill="#2F66F4"
      />
      <path
        d="M8.35286 7.17326C8.07286 7.17326 7.84619 6.94659 7.84619 6.66659V4.59993C7.84619 4.31993 8.07286 4.09326 8.35286 4.09326C8.63286 4.09326 8.85953 4.31993 8.85953 4.59993V6.66659C8.85286 6.94659 8.62619 7.17326 8.35286 7.17326Z"
        fill="white"
      />
      <path
        d="M10.2398 13.3402C9.95981 14.1135 9.21981 14.6668 8.35314 14.6668C7.82648 14.6668 7.30648 14.4535 6.93981 14.0735C6.72648 13.8735 6.56648 13.6068 6.47314 13.3335C6.55981 13.3468 6.64648 13.3535 6.73981 13.3668C6.89314 13.3868 7.05314 13.4068 7.21314 13.4202C7.59314 13.4535 7.97981 13.4735 8.36648 13.4735C8.74648 13.4735 9.12648 13.4535 9.49981 13.4202C9.63981 13.4068 9.77981 13.4002 9.91314 13.3802C10.0198 13.3668 10.1265 13.3535 10.2398 13.3402Z"
        fill="#2F66F4"
      />
    </svg>
  );
};

export const UsersIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#D9D6FF" fillOpacity="0.5" />
      <path
        d="M20.6769 14.5229C18.0972 14.5229 16 16.6202 16 19.1999C16 21.7303 17.9791 23.7783 20.5588 23.8669C20.6375 23.8571 20.7163 23.8571 20.7754 23.8669C20.7951 23.8669 20.8049 23.8669 20.8246 23.8669C20.8345 23.8669 20.8345 23.8669 20.8443 23.8669C23.3649 23.7783 25.344 21.7303 25.3538 19.1999C25.3538 16.6202 23.2566 14.5229 20.6769 14.5229Z"
        fill="#2F66F4"
      />
      <path
        d="M25.6787 26.4858C22.9316 24.6545 18.4516 24.6545 15.6848 26.4858C14.4343 27.3228 13.7451 28.4551 13.7451 29.6662C13.7451 30.8772 14.4343 31.9997 15.675 32.8268C17.0534 33.7523 18.8651 34.2151 20.6768 34.2151C22.4885 34.2151 24.3002 33.7523 25.6787 32.8268C26.9193 31.9898 27.6085 30.8674 27.6085 29.6465C27.5987 28.4354 26.9193 27.3129 25.6787 26.4858Z"
        fill="#2F66F4"
      />
      <path
        d="M31.4985 19.7808C31.6561 21.691 30.2973 23.3648 28.4167 23.5913C28.4068 23.5913 28.4068 23.5913 28.397 23.5913H28.3674C28.3084 23.5913 28.2493 23.5913 28.2001 23.6109C27.245 23.6602 26.3687 23.3549 25.709 22.7937C26.7231 21.8879 27.3041 20.5291 27.1859 19.0522C27.117 18.2546 26.8413 17.526 26.4278 16.9057C26.8019 16.7186 27.2351 16.6005 27.6782 16.5611C29.6081 16.3937 31.3311 17.8313 31.4985 19.7808Z"
        fill="#2F66F4"
      />
      <path
        d="M33.4668 28.8888C33.388 29.8439 32.7775 30.6709 31.7535 31.2322C30.7689 31.7737 29.5283 32.0297 28.2975 32.0002C29.0065 31.3602 29.42 30.5626 29.4988 29.7159C29.5972 28.4949 29.0163 27.3233 27.8545 26.3879C27.1948 25.866 26.4268 25.4525 25.5898 25.1473C27.7658 24.5171 30.5031 24.9405 32.1868 26.2993C33.0926 27.0279 33.5554 27.9436 33.4668 28.8888Z"
        fill="#2F66F4"
      />
    </svg>
  );
};

export const Dot = () => {
  return (
    <svg
      width="18"
      height="5"
      viewBox="0 0 18 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 2.26367C4 3.36824 3.10457 4.26367 2 4.26367C0.89543 4.26367 0 3.36824 0 2.26367C0 1.1591 0.89543 0.263672 2 0.263672C3.10457 0.263672 4 1.1591 4 2.26367Z"
        fill="#2F66F4"
      />
      <path
        d="M11 2.26367C11 3.36824 10.1046 4.26367 9 4.26367C7.89543 4.26367 7 3.36824 7 2.26367C7 1.1591 7.89543 0.263672 9 0.263672C10.1046 0.263672 11 1.1591 11 2.26367Z"
        fill="#2F66F4"
      />
      <path
        d="M18 2.26367C18 3.36824 17.1046 4.26367 16 4.26367C14.8954 4.26367 14 3.36824 14 2.26367C14 1.1591 14.8954 0.263672 16 0.263672C17.1046 0.263672 18 1.1591 18 2.26367Z"
        fill="#2F66F4"
      />
    </svg>
  );
};

export const FilterIcon = () => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 1H4C2.58579 1 1.87868 1 1.43934 1.4122C1 1.8244 1 2.48782 1 3.81466V4.50448C1 5.54232 1 6.06124 1.2596 6.49142C1.5192 6.9216 1.99347 7.18858 2.94202 7.72255L5.85504 9.36238C6.49146 9.72064 6.80967 9.89977 7.03751 10.0976C7.51199 10.5095 7.80408 10.9935 7.93644 11.5872C8 11.8722 8 12.2058 8 12.8729L8 15.5424C8 16.452 8 16.9067 8.25192 17.2613C8.50385 17.6158 8.95128 17.7907 9.84615 18.1406C11.7248 18.875 12.6641 19.2422 13.3321 18.8244C14 18.4066 14 17.4519 14 15.5424V12.8729C14 12.2058 14 11.8722 14.0636 11.5872C14.1959 10.9935 14.488 10.5095 14.9625 10.0976C15.1903 9.89977 15.5085 9.72064 16.145 9.36238L19.058 7.72255C20.0065 7.18858 20.4808 6.9216 20.7404 6.49142C21 6.06124 21 5.54232 21 4.50448V3.81466C21 2.48782 21 1.8244 20.5607 1.4122C20.1213 1 19.4142 1 18 1Z"
        stroke="CurrentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const SettingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.6em"
      height="1.6em"
      viewBox="-2 -4 24 24"
    >
      <path
        fill="currentColor"
        d="M9 12V1a1 1 0 1 1 2 0v11h1a1 1 0 0 1 0 2h-1v1a1 1 0 0 1-2 0v-1H8a1 1 0 0 1 0-2zm7-10V1a1 1 0 0 1 2 0v1h1a1 1 0 0 1 0 2h-1v11a1 1 0 0 1-2 0V4h-1a1 1 0 0 1 0-2zM4 5h1a1 1 0 1 1 0 2H4v8a1 1 0 0 1-2 0V7H1a1 1 0 1 1 0-2h1V1a1 1 0 1 1 2 0z"
      ></path>
    </svg>
  );
};

export const MessageIconCover = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#D9D6FF" fillOpacity="0.5" />
      <path
        d="M13.667 23.9591C13.667 20.8165 13.667 19.2451 14.6433 18.2688C15.6196 17.2925 17.191 17.2925 20.3337 17.2925H23.667C26.8097 17.2925 28.381 17.2925 29.3573 18.2688C30.3337 19.2451 30.3337 20.8165 30.3337 23.9591C30.3337 27.1018 30.3337 28.6732 29.3573 29.6495C28.381 30.6258 26.8097 30.6258 23.667 30.6258H20.3337C17.191 30.6258 15.6196 30.6258 14.6433 29.6495C13.667 28.6732 13.667 27.1018 13.667 23.9591Z"
        stroke="#2F66F4"
        strokeWidth="1.5"
      />
      <path
        d="M30.0511 19.5591C27.5429 21.1894 26.2888 22.0046 24.9667 22.4153C23.0342 23.0157 20.9651 23.0157 19.0326 22.4153C17.7105 22.0046 16.4564 21.1894 13.9482 19.5591"
        stroke="#2F66F4"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M18.667 21.459V23.1257"
        stroke="#2F66F4"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M25.333 21.459V23.1257"
        stroke="#2F66F4"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M19.6426 15.6257C19.9858 14.6547 20.9118 13.959 22.0003 13.959C23.0888 13.959 24.0149 14.6547 24.3581 15.6257"
        stroke="#2F66F4"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const BagIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.66699 11.9596C1.66699 8.81694 1.66699 7.24559 2.6433 6.26928C3.61961 5.29297 5.19096 5.29297 8.33366 5.29297H11.667C14.8097 5.29297 16.381 5.29297 17.3573 6.26928C18.3337 7.24559 18.3337 8.81694 18.3337 11.9596C18.3337 15.1023 18.3337 16.6737 17.3573 17.65C16.381 18.6263 14.8097 18.6263 11.667 18.6263H8.33366C5.19096 18.6263 3.61961 18.6263 2.6433 17.65C1.66699 16.6737 1.66699 15.1023 1.66699 11.9596Z"
        stroke="CurrentColor"
        strokeWidth="1.5"
      />
      <path
        d="M18.0511 7.55957C15.5429 9.1899 14.2888 10.0051 12.9667 10.4158C11.0342 11.0162 8.96509 11.0162 7.03262 10.4158C5.71054 10.0051 4.45644 9.1899 1.94824 7.55957"
        stroke="CurrentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M6.66699 9.45996V11.1266"
        stroke="CurrentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M13.333 9.45996V11.1266"
        stroke="CurrentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M7.64258 3.62663C7.98578 2.65563 8.91181 1.95996 10.0003 1.95996C11.0888 1.95996 12.0149 2.65563 12.3581 3.62663"
        stroke="CurrentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const ScheduleIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.94812 1.33398H10.0522C11.7303 1.33397 13.0546 1.33396 14.0193 1.46115C14.9674 1.58615 15.8193 1.86164 16.2239 2.6472C16.2822 2.76038 16.3314 2.87799 16.371 2.99894C16.6471 3.84142 16.2386 4.63721 15.6567 5.39039C15.065 6.15635 14.1281 7.08408 12.942 8.25863L10.8884 10.2923L12.942 12.326C14.1281 13.5006 15.065 14.4283 15.6567 15.1942C16.2386 15.9474 16.6471 16.7432 16.371 17.5857C16.3314 17.7066 16.2822 17.8243 16.2239 17.9374C15.8193 18.723 14.9674 18.9985 14.0193 19.1235C13.0546 19.2507 11.7303 19.2507 10.0521 19.2507H9.94814C8.27003 19.2507 6.94564 19.2507 5.981 19.1235C5.03287 18.9985 4.18097 18.723 3.77638 17.9374C3.71809 17.8243 3.66889 17.7066 3.62925 17.5857C3.3532 16.7432 3.76172 15.9474 4.34357 15.1942C4.93528 14.4283 5.87213 13.5006 7.05824 12.326L9.1119 10.2923L7.05824 8.25863C5.87213 7.08408 4.93528 6.15635 4.34357 5.39039C3.76172 4.63721 3.3532 3.84142 3.62925 2.99895C3.66889 2.87799 3.71809 2.76038 3.77638 2.6472C4.18097 1.86164 5.03287 1.58615 5.981 1.46115C6.94563 1.33396 8.27002 1.33397 9.94812 1.33398ZM10.0001 9.41272L12.0251 7.40744C13.2567 6.18782 14.1329 5.31819 14.6675 4.62621C15.2181 3.91344 15.248 3.58609 15.1832 3.38817C15.1642 3.33026 15.1406 3.27387 15.1126 3.21954C15.0154 3.03072 14.7553 2.81901 13.8559 2.70042C12.9829 2.58532 11.7415 2.58398 10.0001 2.58398C8.25873 2.58398 7.01737 2.58532 6.1444 2.70042C5.24497 2.81901 4.9849 3.03072 4.88765 3.21954C4.85967 3.27387 4.83609 3.33026 4.81711 3.38817C4.75226 3.58609 4.78214 3.91344 5.33277 4.62621C5.86734 5.31819 6.74357 6.18782 7.97517 7.40745L10.0001 9.41272ZM10.0001 11.1719L7.97517 13.1772C6.74356 14.3968 5.86734 15.2664 5.33277 15.9584C4.78214 16.6712 4.75226 16.9985 4.81711 17.1965C4.83609 17.2544 4.85967 17.3108 4.88765 17.3651C4.9849 17.5539 5.24497 17.7656 6.1444 17.8842C7.01737 17.9993 8.25873 18.0007 10.0001 18.0007C11.7415 18.0007 12.9829 17.9993 13.8559 17.8842C14.7553 17.7656 15.0154 17.5539 15.1126 17.3651C15.1406 17.3108 15.1642 17.2544 15.1832 17.1965C15.248 16.9985 15.2181 16.6712 14.6675 15.9584C14.1329 15.2664 13.2567 14.3968 12.0251 13.1772L10.0001 11.1719ZM7.70847 4.87565C7.70847 4.53047 7.98829 4.25065 8.33347 4.25065H11.6668C12.012 4.25065 12.2918 4.53047 12.2918 4.87565C12.2918 5.22083 12.012 5.50065 11.6668 5.50065H8.33347C7.98829 5.50065 7.70847 5.22083 7.70847 4.87565ZM7.70847 15.709C7.70847 15.3638 7.98829 15.084 8.33347 15.084H11.6668C12.012 15.084 12.2918 15.3638 12.2918 15.709C12.2918 16.0542 12.012 16.334 11.6668 16.334H8.33347C7.98829 16.334 7.70847 16.0542 7.70847 15.709Z"
        fill="CurrentColor"
      />
    </svg>
  );
};
